export const errorDetailsHeaders = [
  {
    label: 'Party_Key',
    key: 'id'
  },
  {
    label: 'Party Name/Organization Name',
    key: 'name'
  },
  {
    label: 'Alias',
    key: 'alias'
  },
  {
    label: 'Segment',
    key: 'segment'
  },
  {
    label: 'Gender',
    key: 'gender'
  },
  {
    label: 'Birth/Inception Date',
    key: 'dob'
  },
  {
    label: 'Nationality',
    key: 'nationality'
  },
  {
    label: 'Country of Birth/Inception',
    key: 'birthOrIncorporationCountry'
  },
  {
    label: 'Country of Residence',
    key: 'residenceCountry'
  },
  {
    label: 'Address',
    key: 'address'
  },
  {
    label: 'Error Details',
    key: 'error'
  }
];
